"use strict";
exports.__esModule = true;
//# sourceMappingURL=global-settings.type.js.map